import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'error-trigger',
  version: '1.0.0',
  properties: [
    {
      key: 'scope',
      label: 'Scope',
      type: 'options',
      required: true,
      default: 'workflow',
      options: [
        { value: 'workflow', name: 'Current Workflow' },
        { value: 'all', name: 'All Workflows' },
      ],
      description: 'Which workflows should trigger this error handler',
    },
    {
      key: 'errorTypes',
      label: 'Error Types',
      type: 'multiOptions',
      required: false,
      default: [],
      options: [
        { value: 'nodeError', name: 'Node Execution Errors' },
        { value: 'timeout', name: 'Timeout Errors' },
        { value: 'validation', name: 'Validation Errors' },
        { value: 'connection', name: 'Connection Errors' },
        { value: 'authentication', name: 'Authentication Errors' },
      ],
      description: 'Filter by specific error types. Leave empty to catch all errors.',
    },
    {
      key: 'includeErrorDetails',
      label: 'Include Error Details',
      type: 'boolean',
      default: true,
      description: 'Include detailed error information in the output (stack trace, node info, etc.)',
    },
    {
      key: 'continueOnError',
      label: 'Continue Workflow on Error Handler Failure',
      type: 'boolean',
      default: false,
      description: 'If the error handling workflow also fails, continue without raising another error',
    },
  ],
};

export default schema;
